<template>
  <div class="header-auth">
    <SignUpBlock v-if="clientStore.isAuth === false" />
    <ProfileBlock v-if="clientStore.isAuth" />
    <pPopup
        :visible="authPopupStore.visible"
        @close="authPopupStore.visible = false"
    >
      <template v-slot:content>
        <component :is="authPopupStore.activeForm" class="form" />
      </template>
    </pPopup>
  </div>
</template>

<script lang="ts" setup>
import SignUpBlock from "./components/SignUpBlock.vue";
import pPopup from '../common/pPopup/pPopup.vue'
import ProfileBlock from "@/authSection/components/ProfileBlock.vue";
import { useAuthPopup } from './store/authPopup'
import { onMounted } from "vue";
import { useClientStore } from "@/authSection/store/clientStore";

const authPopupStore = useAuthPopup()
const clientStore = useClientStore()

onMounted(() => {
  clientStore.setAuthStatus()
})
</script>

<style scoped lang="scss">
.header {
  &-auth {
    display: flex;
    gap: 6px;
    align-items: center;
  }

  &__popup {
    max-width: 480px;
    width: 100%;
  }
}

.form {
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
}
</style>
